import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';

const SIDE = 'https://images.unsplash.com/photo-1517976547714-720226b864c1?auto=format&fit=crop&w=1200&q=80';

export default function Signup() {
  const { signup } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: '', companyName: '', email: '', password: '' });
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);

  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    setErr(''); setBusy(true);
    try {
      const res = await signup(form);
      // When email verification is enabled the backend asks the user to confirm
      // a code first (no session yet). Otherwise signup logged us straight in.
      if (res && res.pendingVerification) {
        nav(`/verify?email=${encodeURIComponent(res.email || form.email)}`);
      } else {
        nav('/welcome');
      }
    } catch (e) {
      setErr(e.message || 'Signup failed');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="auth-split">
      <div className="auth-left">
        <div className="auth-card">
          <div className="auth-brand">
            <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: 8, color: 'inherit', textDecoration: 'none' }}>
              <img src="/cnerzy-logo.png" alt="cnerzy" className="brand-logo" />
              <span>Rivet</span>
            </Link>
          </div>
          <h1>Start free</h1>
          <p className="muted">No credit card. 30 RFQs on us. Cancel anytime.</p>
          <form onSubmit={submit}>
            <label className="field">
              <span className="label">Your name</span>
              <input className="input" autoFocus value={form.name} onChange={(e) => set('name', e.target.value)} />
            </label>
            <label className="field">
              <span className="label">Company</span>
              <input className="input" value={form.companyName} onChange={(e) => set('companyName', e.target.value)} placeholder="Acme Aerospace Distribution" />
            </label>
            <label className="field">
              <span className="label">Work email</span>
              <input className="input" type="email" value={form.email} onChange={(e) => set('email', e.target.value)} />
            </label>
            <label className="field">
              <span className="label">Password (8+ chars)</span>
              <input className="input" type="password" value={form.password} onChange={(e) => set('password', e.target.value)} />
            </label>
            {err && <div className="banner risk">{err}</div>}
            <button className="btn" style={{ width: '100%' }} disabled={busy}>{busy ? 'Creating account…' : 'Create account'}</button>
          </form>
          <div className="auth-footer">
            Already on Rivet? <Link to="/login">Sign in</Link>
          </div>
        </div>
      </div>
      <div className="auth-right" style={{ backgroundImage: `linear-gradient(135deg, rgba(0,0,0,0.78), rgba(0,0,0,0.55)), url(${SIDE})` }}>
        <div className="auth-right-inner">
          <div className="kicker light">Built for aerospace procurement</div>
          <h2>Turn the email swamp into a defensible decision.</h2>
          <blockquote>
            "We stopped discovering QPL mismatches at receiving. Now we catch them at comparison."
            <cite>— Pilot distributor, Q2 2026</cite>
          </blockquote>
        </div>
      </div>
    </div>
  );
}
